import './TextEditor.scss';
import classNames from 'classnames';
import { useCurrentUser } from '@hooks';
import { Editor, EditorProps, EditorRef } from '@ui/Editor';
import React, { forwardRef } from 'react';

export const TextEditor = forwardRef<EditorRef | null, EditorProps>(({ className, ...rest }, ref) => {
	const { isReadOnly } = useCurrentUser();

	const { isReadOnly: propsIsReadOnly } = rest;

	return (
		<Editor
			{ ...rest }
			className={ classNames('periscope-text-editor', className) }
			editOnClick
			isReadOnly={ propsIsReadOnly || isReadOnly }
			ref={ ref }
			saveOnBlur />
	);
});
